let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
    // console.log("aaaaaaaaaaaaaaaaaaaaa");
// kgUpdateAppstelDescription();
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}


  // function kgUpdateAppstelDescription() {
  //       const kgSource = document.querySelector(".appstleSellingPlanDescription");
  //       const kgTarget = document.querySelector(".appstle_subscription_description_text");
  //               const kgAppstleTitle = document.querySelector(".appstle_widget_title");

  //       if (kgSource && kgTarget) {
  //         console.log("BBBBBBBBBBBBBBBBBBBBBBBBB");
  //         kgTarget.innerHTML = kgSource.innerHTML;
  //         window.kgAppstleDescriptionHtml = kgSource.innerHTML;
  //                   kgAppstleTitle.setAttribute('data-number', 3);

  //       }
  //     }

// subscribe(PUB_SUB_EVENTS.variantChange, () => {
//   setTimeout(() => {
//     kgUpdateAppstelDescription();
//   }, 500);
// });